// Mirrors brand-survey-app/src/utils/themeContrast.ts so the admin survey
// preview computes the same text colours the live survey will render.
export const relativeLuminance = (hex: string | undefined): number => {
    const normalised = (hex || '').trim().replace(/^#/, '');
    const expanded = normalised.length === 3
        ? normalised.split('').map((c) => c + c).join('')
        : normalised;
    if (!/^[0-9a-fA-F]{6}$/.test(expanded)) {
        return 0; // unparseable → treat as dark, preserving white-text behaviour
    }
    const channels = [0, 2, 4].map((offset) => {
        const c = parseInt(expanded.slice(offset, offset + 2), 16) / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
};

// Threshold 0.4 (not 0.5): mid-light brand colours like gold #D4AF37
// (luminance 0.449) read far better with dark text (7.7:1 vs 2.1:1).
export const isLightColor = (hex: string | undefined): boolean =>
    relativeLuminance(hex) > 0.4;

export const textColorOn = (background: string | undefined): string =>
    isLightColor(background) ? '#212121' : '#FFFFFF';

export const mutedTextColorOn = (background: string | undefined): string =>
    isLightColor(background) ? 'rgba(33, 33, 33, 0.7)' : 'rgba(255, 255, 255, 0.75)';

export const subtleBorderOn = (background: string | undefined): string =>
    isLightColor(background) ? 'rgba(33, 33, 33, 0.4)' : 'rgba(255, 255, 255, 0.4)';
